import { createContext } from 'react';

import { AppContext } from '@willow/shared-iso';

export const EnvironmentContext = createContext<AppContext>('development');
